import * as Yup from 'yup';
import getLanguage, {getAvailableFormLanguages, LanguageId} from '../../../models/utils/Languages';
import {optName} from './OptionsList';
import FieldConfiguration from '../../../models/form/FieldConfiguration';
import DropdownField from '../../../models/form/DropdownField';
import {IOption} from '../../../ui/form/UIOption';

export default class OptionsLanguageManager {
  constructor(
    protected readonly languages: LanguageId[],
    protected readonly configuration?: FieldConfiguration,
  ) {
  }

  validationObject() {
    return Object.fromEntries(this.languages.map((languageId) =>
      [optName(languageId), Yup.array().of(Yup.string().required('Required')).min(1, 'Minimum of one option').required('At least one option required')]));
  }

  // eslint-disable-next-line class-methods-use-this
  initialFormValues() {
    const field = this.configuration?.field;
    return Object.fromEntries(getAvailableFormLanguages().map((languageId) => {
      let values = [''];
      if (DropdownField.isDropdown(field)) {
        values = field.options.get(languageId) || [''];
      }
      return [optName(languageId), values];
    }));
  }

  availableLanguages(): IOption<boolean>[] {
    const availableLanguages = getAvailableFormLanguages().filter((x) => this.languages.indexOf(x) < 0);
    return availableLanguages
      .map((langId) => ({
        label: getLanguage(langId), value: langId, selected: false, id: langId,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }
}
